export default "__VITE_ASSET__BT8Y8OVO__"